import { jsonCopy } from '../../../utility/genericUtility';
import { datiTitolareEffInizializzato } from '../componentiBase/sezioniAnagrafica';

export const datiTitolareEff = jsonCopy(datiTitolareEffInizializzato);


